// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3ov9B","empty":"ModalGraph_empty__28D84"};